var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined / Reorder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1331 6.63553C15.7817 6.98695 15.212 6.98695 14.8606 6.63553L12.74 4.51485L10.6195 6.63553C10.2681 6.98695 9.69839 6.98695 9.34699 6.63553C8.99559 6.2841 8.99559 5.71433 9.34699 5.36291L12.1038 2.60593C12.4552 2.25451 13.0249 2.25451 13.3763 2.60593L16.1331 5.36291C16.4845 5.71433 16.4845 6.2841 16.1331 6.63553Z",
    fill: "#146eb4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39932 9.19877C2.90237 9.19877 2.49951 9.60165 2.49951 10.0986C2.49951 10.5956 2.90237 10.9985 3.39932 10.9985H21.5955C22.0925 10.9985 22.4953 10.5956 22.4953 10.0986C22.4953 9.60165 22.0925 9.19877 21.5955 9.19877H3.39932Z",
    fill: "#146eb4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39932 13.1982C2.90237 13.1982 2.49951 13.6011 2.49951 14.0981C2.49951 14.5951 2.90237 14.998 3.39932 14.998H21.5955C22.0925 14.998 22.4953 14.5951 22.4953 14.0981C22.4953 13.6011 22.0925 13.1982 21.5955 13.1982H3.39932Z",
    fill: "#146eb4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6195 17.3613C10.2681 17.0098 9.69841 17.0098 9.34702 17.3613C8.99562 17.7127 8.99562 18.2825 9.34702 18.6339L12.1038 21.3909C12.4552 21.7423 13.0249 21.7423 13.3763 21.3909L16.1331 18.6339C16.4845 18.2825 16.4845 17.7127 16.1331 17.3613C15.7817 17.0098 15.212 17.0098 14.8606 17.3613L12.7401 19.4819L10.6195 17.3613Z",
    fill: "#146eb4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.ef356d4eaeb0163fa5fab955a6fb7acf.svg";
export { ForwardRef as ReactComponent };